import { render, staticRenderFns } from "./DefaultParams.vue?vue&type=template&id=3a0e39eb"
import script from "./DefaultParams.vue?vue&type=script&lang=js"
export * from "./DefaultParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports